import { provideTransloco } from "@jsverse/transloco";
import { TranslocoHttpLoader } from "../../transloco-loader";
import { Injectable, isDevMode } from "@angular/core";

@Injectable({ providedIn: "root" })
export class TranslocoService {

}

export const provideTranslation = provideTransloco({
    loader: TranslocoHttpLoader,
    config: {
        availableLangs: ["da"],
        defaultLang: "da",
        fallbackLang: "da",
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
        missingHandler: {
            allowEmpty: true,
            logMissingKey: isDevMode(),
        },
    },
});